import { Carousel, Slide } from "vue-carousel";
import axios from "axios";
import articleModal from "../articleModal/index.vue";

export default {
  name: "relatedArticlesSection",
  components: {
    Carousel,
    Slide,
    articleModal
  },
  data() {
    return {
      colorImg: "",
      allArticles: [],
      pageSize: 16,
      currentPage: 1,
      productUser: [],
      picNumber: 0,
     
      sortedData: [],
      selectedFilters: [],
      dataToFilter: [],
      FilterAll: "",
      quantiteMax: 1,
      quantiteMin: 1,
      btnValue: "",
      selectDetailsSize: "",
      detailsElement: [],
      detailsElementSize: [],
      detailsElementPointure: [],
      detailsElementDimmension: [],
      dimmensionLargeur: 0,
      dimmensionLongueur: 0,
      maxW: 0,
      maxH: 0,
      idSelectedElement: "",
      // sizeProduct:["x","y"],
      model: {
        quantite: 1,
      },
      lastArticles: [],
    };
  },
  created() {
    this.getAllArticle();
  },
  methods: {
    modelContent(element, index) {
      this.$store.state.product.productDetail=element
      this.$store.state.product.productModalState=true
    },
    getAllArticle() {
      axios
      .get(
        "https://giftstore-blog.herokuapp.com/api/product/get/related?id=" +
        this.$route.query.id_article
      )
        .then((response) => {
          console.log("related", response);
          this.lastArticles = response.data.final;
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    },
    deleteWishlist(id) {
      var product = {
        user: window.localStorage.getItem("Giftstore-U"),
        product: id,
      };
      console.log("fdshgfhgjsf", product);
      axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/user/wishlist/remove",
          product
        )
        .then((response) => {
          this.getElements();
          this.$toast.open({
            message: "Produit bien supprimé de la wishlist ",
            type: "success",
            // position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.$toast.open({
            message: "Error lors de la suppression du produit",
            type: "error",
            // position: "top-right",
            // all of other options may go here
          });
        });
    },
    addWishlist(id) {
      var product = {
        user: window.localStorage.getItem("Giftstore-U"),
        product: id,
      };
      if (window.localStorage.getItem("Giftstore-U")) {
        axios
          .post(
            "https://giftstore-blog.herokuapp.com/api/user/wishlist/add",
            product
          )
          .then((response) => {
            this.$store.commit("setUserInfo", response.data.user);
            console.log(response);
            this.getElements();
            this.$toast.open({
              message: "Produit bien ajouté à la wishlist",
              type: "success",
              // position: "top-right",
              // all of other options may go here
            });
          })
          .catch((error) => {
            console.error("There was an error!", error);
            this.$toast.open({
              message: "Error lors de l'ajout du produit",
              type: "error",
              // position: "top-right",
              // all of other options may go here
            });
          });
      } else {
        this.$toast.open({
          message: "Vous devez être connecter",
          type: "info",
        });
      }
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

   
    GetProductNumber() {
      //extracting the theme number from local storage
      if (localStorage.getItem("ProductNumber") === null) {
        return 0;
      } else {
        return localStorage.getItem("ProductNumber");
      }
    },

    addedwhislit(id) {
      // ._id
      console.log(this.$store.getters.getUserInfo.wishList);
      var wishListTab = [];
      if (this.$store.getters.getUserInfo.wishList == "undefined") {
        wishListTab = this.$store.getters.getUserInfo.wishList;
        for (let i = 0; i <= wishListTab.length - 1; i++) {
          console.log("tetetetet", wishListTab[i], id);
          if (wishListTab[i] == id) {
            return false;
          }
        }
        return true;
      } else {
        return true;
      }
    },
    addedElement(id) {
      var ProNum = this.GetProductNumber();
      var idElement;
      for (let i = 1; i <= ProNum; i++) {
        idElement = JSON.parse(localStorage.getItem("product" + i));
        if (idElement.id == id) {
          return false;
        }
      }
      return true;
    },
    deleteArticle(id) {
      var TabThemes = [];
      var nb = this.GetProductNumber();
      window.localStorage.removeItem("ProductNumber");
      var idElement;
      for (var k = 1; k <= nb; k++) {
        idElement=JSON.parse(localStorage.getItem("product" + k))
        if( idElement.id != id) {
          TabThemes.push(JSON.stringify(idElement));
        }
        window.localStorage.removeItem("product" + k);
      }
      for (var j = 1; j <= TabThemes.length; j++) {
        localStorage.setItem("product" + j, TabThemes[j - 1]);
      }
      localStorage.setItem("ProductNumber", TabThemes.length);
      this.getElements();
      this.$toast.open({
        message: "Produit supprimé au Panier",
        type: "success",
      });
      this.$store.commit("setbasket", TabThemes);
    },
    addArticle(id) {
      let ProNum = this.GetProductNumber();
      var TabThemes = [];
      ProNum++;
      var product
      if (this.detailsElement.typeArticle == "vetements") {
        product = {
          nb: this.model.quantite,
          taille: this.selectDetailsSize,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "chaussure") {
         product = {
          nb: this.model.quantite,
          pointure: this.selectDetailsPointure,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "tapis") {
        product = {
          nb: this.model.quantite,
          largeur: this.dimmensionLargeur,
          longueur: this.dimmensionLongueur,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "autre") {
        product = {
          nb: this.model.quantite,
          couleur: this.colorImg,
          id: id,
        };
      }
      localStorage.setItem("ProductNumber", ProNum);
      localStorage.setItem("product" + ProNum, JSON.stringify(product));
      console.log(
        "object",
        JSON.parse(localStorage.getItem("product" + ProNum))
      );
      this.getElements();
      this.$toast.open({
        message: "Produit bien ajouté au Panier",
        type: "success",
      });
      for (var k = 1; k <= ProNum; k++) {
        TabThemes.push(localStorage.getItem("product" + k));

      }
      this.$store.commit("setbasket", TabThemes);
    },
    productBtnMore() {
      if (this.allArticles.length > 16) {
        return true;
      } else {
        return false;
      }
    },
    detailArticlePage(id) {
      return "/detail-article?id_article=" + id;
    },

    // updateCountry (person, country) {
    //   person.country = country;
    // },
    getValueDimmension(type) {
      if (type == "1") {
        if (
          this.detailsElementDimmension[0].widthMax < this.dimmensionLargeur ||
          this.detailsElementDimmension[0].widthMin > this.dimmensionLargeur
        ) {
          // this.$toast.open({
          //   message:
          //     "Largeur maximal est " +
          //     this.detailsElementDimmension[0].widthMax,
          //   type: "error",
          //   // position: "top-right",
          //   // all of other options may go here
          // });
        }
      } else {
        if (
          this.detailsElementDimmension[0].heightMax <
            this.dimmensionLongueur ||
          this.detailsElementDimmension[0].heightMin > this.dimmensionLongueur
        ) {
          // this.$toast.open({
          //   message:
          //     "Longeur maximal est " +
          //     this.detailsElementDimmension[0].heightMax,
          //   type: "error",
          //   // position: "top-right",
          //   // all of other options may go here
          // });
        }
      }
    },
 
    getImage(img) {
      console.log(this);
      if (
        img.includes(
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/"
        )
      ) {
        this.modelImage0 = img;
      } else {
        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          img;
      }
    },
    styleImgSrc: function(element) {
      var imgSrc1, imgSrc2;
      if (element.typeArticle == "vetements") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[1] +
          ")";
      } else if (element.typeArticle == "chaussure") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[1] +
          ")";
      } else if (element.typeArticle == "tapis") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[1] +
          ")";
      } else if (element.typeArticle == "autre") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[1] +
          ")";
      }
      return {
        "--imgSrc": imgSrc1,
        "--imgSrc-hover": imgSrc2,
      };
    },
  },
};
